module.exports = (lang, langs, defaultLang, translations) => {
  const i18n = require('i18next').default
  const Backend = require('i18next-http-backend').default
  const LanguageDetector = require('i18next-browser-languagedetector').default
  const { initReactI18next } = require('react-i18next')

  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: defaultLang,
      whitelist: langs,
      resources: translations,

      interpolation: {
        escapeValue: false,
      },

      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },

      detection: {
        order: ['path'],
      },

      react: {
        // https://github.com/i18next/react-i18next/issues/715#issuecomment-463954682
        useSuspense: false,
        transKeepBasicHtmlNodesFor: [
          'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
          'p',
          'strong', 'b',
          'em', 'i',
          'u',
        ],
      },
    })

  i18n.changeLanguage(lang)

  return i18n
}
